import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import SettingsWrapper from '../SettingsWrapper.vue';
import SettingsContent from '../Wrapper.vue';
import FlowsIndex from './Index.vue';
import FlowEditor from './FlowEditor.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/flows'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'flows_list',
          component: FlowsIndex,
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_BOTS,
            permissions: ['administrator', 'agent_bot_manage'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/flows'),
      component: SettingsContent,
      // No headerTitle/icon/showBackButton: the editor renders its own back button and title
      // inside its canvas toolbar instead of the shared Settings page header, so the canvas can
      // start right under the app chrome instead of stacking under a second header row.
      children: [
        {
          path: ':flowId',
          name: 'flows_edit',
          component: FlowEditor,
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_BOTS,
            permissions: ['administrator', 'agent_bot_manage'],
          },
        },
      ],
    },
  ],
};
